import React from 'react';

interface JobPostingsProps {}

const JobPostings: React.FC<JobPostingsProps> = () => {
  const frameRef = React.useRef<HTMLIFrameElement>();
  const [height, setHeight] = React.useState<number>(800);
  const handleLoad = React.useCallback(() => {
    const scrollHeight = frameRef.current?.scrollHeight;
    if (scrollHeight) {
      setHeight(scrollHeight);
    }
  }, []);

  return (
    <section>
      <iframe
        width="100%"
        height={height}
        title="HRM Direct Career Site"
        src="//woodmen.hrmdirect.com/employment/job-openings.php?search=true&amp;nohd=&amp;dept=-1&amp;city=-1&amp;state=-1"
        frameBorder="0"
        allowTransparency
        onLoad={handleLoad}
      />
    </section>
  );
};

export default JobPostings;
